import type { TabOption } from '../interfaces'

export const findActiveTab = <T,>(
  options: Array<TabOption<T>>,
  startPosition: number,
  step: 1 | -1,
): number => {
  const totalTabs = options.length

  const candidates = [...Array(totalTabs).keys()].map(
    (index) => (startPosition + index * step + totalTabs) % totalTabs,
  )

  return candidates.find((index) => !options[index]?.disabled) ?? startPosition
}
